import { filterBrand } from "./filter.js";
function init() {
    filterBrand();
}

export {
    init   
}
